<template>
  <PageWithLayout>
    <div class="section_comm">
      <div class="section_head">
          <h2 id="kakaoBody" class="tit_section">공지사항</h2>
          <p class="desc_section">T-Fac 서비스와 관련된 새로운 소식을 전해드립니다.</p>
      </div>
      <div class="section_body">
        <div class="tbl_comm tbl_list">
          <table>
            <colgroup>
            <col width="100%"/>
            </colgroup>
            <tbody>
              <tr>
                <td class="align_left">
                  <div class="header_tbl">
                    <h3 class="tit_view">{{notice.title}}</h3>
                    <span class="txt_date"><span class="screen_out">등록 날짜</span>{{notice.noticeRegDt | dateFromatDot2}}</span>
                  </div>
                </td>

              </tr>
              <tr>
                <td colspan="2" class="td_content align_left" >
                  <tinymce-editor
                      :contents="notice.contents"
                  />
                  <!-- 공지사항 파일 추가 -->
                  <div class="file_view" v-if="notice.attachments && notice.attachments.length > 0">
                    <div class="file_info" v-for="(item, index) in notice.attachments" :key="`notice_${notice.seq}_${index}`">
                      <!--<a :href="item.url" download>{{item.orgName}}</a>-->
                      <button type="button" class="btn_file" @click="saveFile(item.url, item.orgName)">
                        <span class="ico_brand" :class="`ico_${fileClassName(item.mimeType)}`">{{item.orgName}}</span>
                        <span class="txt_file">{{item.orgName}}</span>
                      </button>
                    </div>
                  </div>
                  <!-- 공지사항 파일 추가 끝 -->
                  <!-- <br><br>대상<br>- 포인트 적립 및 사용이 가능한 모든 구매/공급 사<br><br>대상<br>- 포인트 적립 및 사용이 가능한 모든 구매/공급 사<br><br>대상<br>- 포인트 적립 및 사용이 가능한 모든 구매/공급 사 -->
                </td>
              </tr>
              <tr v-if='isprevNotice'>
                <td class="align_left">
                  <router-link :to="{name : 'NoticeView' , params: {id : prevNotice.seq }}" class="link_move">
                    <span class="txt_pagemove">이전글<span class="ico_brand ico_prev"></span></span>
                    <p class="txt_item">{{prevNotice.title}}</p>

                  </router-link>
                </td>
              </tr>
              <tr v-if='isnextNotice'>
                <td class="align_left">
                  <router-link :to="{name : 'NoticeView' , params: {id : nextNotice.seq }}" class="link_move">
                    <span class="txt_pagemove">다음글<span class="ico_brand ico_prev"></span></span>
                    <p class="txt_item">{{nextNotice.title}}</p>
                  </router-link>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="section_foot">
        <button class="btn_gray" @click="onClickGoToList">목록으로</button>
      </div>
    </div>
  </PageWithLayout>
</template>
<script>
import FileSaver from 'file-saver'
import PageWithLayout from '@/components/layout/PageWithLayout';
import TinymceEditor from "@/components/common/editor/TinymceEditor";
import Api from '../../api/notice'

export default {
  name: 'NoticeView',
  components: {
    PageWithLayout,
    TinymceEditor,
  },
  watch: {
    $route(to, from, next) {
      this.paramsId = to.params.id;
      this.noticeDetail(this.paramsId)
    }
  },
  data(){
    return{
      paramsId : 0,
      notice : [],
      isprevNotice : false,
      prevNotice : {
        seq : '',
        title : '',
        regDt : ''
      },
      isnextNotice : false,
      nextNotice : {
        seq : '',
        title : '',
        regDt : ''
      },
      extentionList: ['pdf','png','jpg','zip','etc','xls', 'jpeg'],
    }
  },
  created() {
    this.paramsId = this.$route.params.id;
    this.noticeDetail(this.paramsId);
  },
  methods:{
    async noticeDetail(paramsId){
      // 공지사항 아이디
      const seq = paramsId;

      try {

        var notice = await Api.noticeDetail(seq);
        this.notice = notice.result[0]

        // 이전글
        const prev = this.notice.prevNotice;
        if(prev != null){
          this.isprevNotice = true;
          this.prevNotice.title = prev.title;
          this.prevNotice.regDt = this.$moment(prev.noticeRegDt).format('YYYY-MM-DD')
          this.prevNotice.seq = prev.seq
        }else{
          this.isprevNotice = false
        }

        // 다음글
        const next = this.notice.nextNotice;
        if(next != null){
          this.isnextNotice = true;
          this.nextNotice.title = next.title;
          this.nextNotice.regDt = this.$moment(next.noticeRegDt).format('YYYY-MM-DD')
          this.nextNotice.seq = next.seq
        }else{
          this.isnextNotice = false;
        }

      }
      catch(err){
        console.log(err)
      }
    },
    onClickGoToList(){
      this.$router.push(`${this.$routerPath.NOTICE_LIST}`);
    },
    fileClassName(mimeType) {
      const type = this.extentionList.find(item=>mimeType.indexOf(item) > -1);
      return !type ? 'etc' :
        type === 'jpeg' ? 'jpg' :
        type;
    },
    saveFile(url, fileName) {
      FileSaver.saveAs(url, fileName);
    }
  },
}
</script>
<style scoped>
.file_view{display:block;margin-top:40px;padding:0 24px 8px 0}/* overflow-x:hidden;overflow-y:auto;height:48px; */
.file_view .file_info{margin-top:8px}
.file_view .file_info:first-child{margin-top:0}
.file_view >>> .item_file{font-size:0}
.file_view >>> .btn_file{display:block;padding-left:25px;line-height:18px;outline:none;text-indent:-25px;text-align:left}
.file_view >>> .btn_file + .btn_file{margin-top:8px}
.file_view >>> .btn_delete{display:block;padding-left:46px;outline:none;text-indent:-46px;text-align:left}
.file_view >>> .btn_delete + .btn_delete{margin-top:8px}
.file_view >>> .ico_delete{margin:2px 11px 2px 0}

.file_view >>> .ico_pdf,
.file_view >>> .ico_png,
.file_view >>> .ico_jpg,
.file_view >>> .ico_zip,
.file_view >>> .ico_etc,
.file_view >>> .ico_xls{margin-right:7px}

.file_view >>> .txt_file{font-size:13px;line-height:18px;color:#888;letter-spacing:-.05em;vertical-align:top;word-wrap:break-word;word-break:break-all}
.file_uploaded{overflow:inherit;height:inherit;margin:0;padding:7px 0 8px}
.file_uploaded >>> .txt_file{color:#5551CE;text-decoration:underline}

.file_ellip{height:auto}
.file_ellip >>> .btn_file{display:block;width:100%;overflow:hidden;white-space:nowrap;text-overflow:ellipsis}
</style>
